import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getVisitorId() {
  try {
    let vid = localStorage.getItem('cc_vid');
    if (!vid) {
      vid = 'v_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem('cc_vid', vid);
    }
    return vid;
  } catch {
    return 'v_anonymous';
  }
}

export function getHeroVariant() {
  try {
    let v = localStorage.getItem('cc_hero_variant');
    if (!v || !['A', 'B', 'C'].includes(v)) {
      const r = Math.random();
      v = r < 0.34 ? 'A' : r < 0.67 ? 'B' : 'C';
      localStorage.setItem('cc_hero_variant', v);
    }
    return v;
  } catch {
    return 'A';
  }
}

export function track(event, props = {}) {
  try {
    const event_id = Math.random().toString(36).slice(2) + Date.now().toString(36);
    axios.post(`${API_URL}/events`, { event, props, visitor_id: getVisitorId(), event_id }).catch(() => {});
  } catch { /* analytics must never break the app */ }
}
